export default [
  {
    key: 'name',
    label: 'field.locationName',
    type: 'text',
    operator: '%',
  },
];